var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99993 0.766602C11.9948 0.766602 15.2333 4.00508 15.2333 7.99993C15.2333 11.9948 11.9948 15.2333 7.99993 15.2333C4.00508 15.2333 0.766602 11.9948 0.766602 7.99993C0.766602 4.00508 4.00508 0.766602 7.99993 0.766602ZM7.99993 1.89993C4.631 1.89993 1.89993 4.631 1.89993 7.99993C1.89993 11.3689 4.631 14.0999 7.99993 14.0999C11.3689 14.0999 14.0999 11.3689 14.0999 7.99993C14.0999 4.631 11.3689 1.89993 7.99993 1.89993ZM7.99993 7.43327C8.28882 7.43327 8.52722 7.64944 8.56219 7.92885L8.5666 7.99993V10.6666C8.5666 10.9796 8.3129 11.2333 7.99993 11.2333C7.71105 11.2333 7.47265 11.0171 7.43768 10.7377L7.43327 10.6666V7.99993C7.43327 7.68697 7.68697 7.43327 7.99993 7.43327ZM8.0066 4.7666C8.31956 4.7666 8.57327 5.02031 8.57327 5.33327C8.57327 5.62216 8.35709 5.86055 8.07768 5.89552L7.99993 5.89993C7.68697 5.89993 7.43327 5.64623 7.43327 5.33327C7.43327 5.04438 7.64944 4.80598 7.92885 4.77102L8.0066 4.7666Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayInfo);
export default __webpack_public_path__ + "static/media/gray-info.b4e9c10a6d1cd8b5ffe8166a9568c15d.svg";
export { ForwardRef as ReactComponent };